import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';
import Header from './components/header';
import { ServiceCloud } from './components/service-cloud';
import navLinks from '../shared/navLinks';

const NavLinkWrapper = ({ children, className, href }) => {
  return <a className={className} href={href}>{children}</a>;
};

const BannerComponent = (props) => (
  <CommonChrome.Banner type={props.type}>
    <div dangerouslySetInnerHTML={{ __html: props.msg }}></div>
  </CommonChrome.Banner>
);

const Chrome = (props) => {
  const {
    activeKey,
    chatParams,
    currentOrg,
    currentUser,
    environment,
    gqlBaseUrl,
    inverted,
    isHeroku,
    isDigitalOcean,
    isInvoiced,
    maxSearchResults,
    organizations,
    pathname,
    section,
    showSwo,
    swicusOrgId,
    systemNotice,
    usesSso,
  } = props;

  const [onChatClick, setOnChatClick] = useState();

  // setOnChatClick/setState behaves differently when passed a function.
  // Instead of setting the state to the argument, it calls the function with
  // the old state, then sets the new state to the return value of the function.
  const enableLiveChat = (onChatClick) => setOnChatClick(() => onChatClick);

  return (
    <CommonChrome
      activeKey={activeKey}
      chromeless={false}
      hasSidebar={false}
      links={navLinks(isHeroku, isDigitalOcean, isInvoiced, onChatClick, gqlBaseUrl, currentUser.admin)}
      LinkWrapper={NavLinkWrapper}
      banner={
        systemNotice.active &&
        <BannerComponent
          type={systemNotice.kind}
          msg={systemNotice.message}
        />
      }
    >
      <Header
        currentOrg={currentOrg}
        currentUser={currentUser}
        environment={environment}
        inverted={inverted}
        maxSearchResults={maxSearchResults}
        organizations={organizations}
        pathname={pathname}
        section={section}
        showSearch={!isHeroku}
        showSwo={showSwo}
        swicusOrgId={swicusOrgId}
        usesSso={usesSso}
      />
      <ServiceCloud
        chatParams={chatParams}
        company={currentOrg.name}
        email={currentUser.email}
        enableLiveChat={enableLiveChat}
      />
    </CommonChrome>
  );
};

 $(function() {
  ReactDOM.render(<Chrome {...PT.chrome} />, document.getElementById('cloud-ui-chrome'));
});
